// actions
import {
  DESTINATIONCHARGERS_TOGGLE_UI,
  DESTINATIONCHARGERS_REMOVE_ANIMATION,
  DESTINATIONCHARGERS_HYDRATE_DATA,
  DESTINATIONCHARGERS_FETCH_REQUEST,
  DESTINATIONCHARGERS_FETCH_SUCCESS,
  DESTINATIONCHARGERS_FETCH_FAILURE,
  DESTINATIONCHARGERS_DELETE_CHARGERS,
  DESTINATIONCHARGERS_IS_CHARGERS,
} from './actions';

const Superchargers = (
  state = {
    isLoading: false,
    destinationChargers: [],
    showDestinationChargers: false,
    isDestinationChargers: false,
    animationName: '',
    translateX: '',
    animationTimeout: 25,
    btnLabel: 'Back to Route',
    body: {
      singular:
        '<p><strong>Charging Details</strong><br/>{CHARGERS} connector, up to {KILOWATTS} KW</p>',
      plural:
        '<p><strong>Charging Details</strong><br/>{CHARGERS} connectors, up to {KILOWATTS} KW</p>',
    },
    label: '{DURATION} mi',
  },
  action,
) => {
  switch (action.type) {
    case DESTINATIONCHARGERS_FETCH_REQUEST:
      return {
        ...state,
        isLoading: true,
      };
    case DESTINATIONCHARGERS_FETCH_SUCCESS: {
      const newState = Object.assign({}, state);
      newState.isLoading = false;
      newState.destinationChargers = action.destinationChargers;
      return newState;
    }
    case DESTINATIONCHARGERS_FETCH_FAILURE:
      return {
        ...state,
        isLoading: false,
      };
    case DESTINATIONCHARGERS_TOGGLE_UI:
      return {
        ...state,
        showDestinationChargers: action.showDestinationChargers,
        animationName: action.showDestinationChargers ? 'slideOut' : 'slideIn',
        translateX: action.showDestinationChargers
          ? 'translate3d(-100%, 0, 0)'
          : 'translate3d(0, 0, 0)',
      };
    case DESTINATIONCHARGERS_REMOVE_ANIMATION:
      return {
        ...state,
        animationName: action.animationName,
      };
    case DESTINATIONCHARGERS_HYDRATE_DATA:
      return {
        ...state,
        btnLabel: action.data.btnLabel,
        body: { ...action.data.body },
        label: action.data.label,
      };
    case DESTINATIONCHARGERS_DELETE_CHARGERS:
      return {
        ...state,
        destinationChargers: [],
      };
    case DESTINATIONCHARGERS_IS_CHARGERS:
      return {
        ...state,
        isDestinationChargers: action.isDestinationChargers,
      };
    default:
      return state;
  }
};

export default Superchargers;
